import toast from 'react-hot-toast';
import React, { useCallback, useEffect } from 'react';
import { useUserStore } from '../store';
import { useSocketIOContext } from '../components/SocketIOContext';

type AchievementMessage = {
  id?: number;
  name?: string;
  desc?: string;
};

export const useAchievementListener = () => {
  const achievements = useUserStore((state) => state.user.achievements);
  const setAchievements = useUserStore((state) => state.setAchievements);
  const { socket } = useSocketIOContext();

  const handleUnlockEvent = useCallback(
    (data: AchievementMessage) => {
      console.log('WS DATA', data);
      const { id, name, desc } = data;
      if (typeof id !== 'number') return;

      if (!achievements.includes(id)) {
        setAchievements([...achievements, id]);
        toast(
          () => (
            <span>
              <span className="text-xs text-white/[.6]">Achievement unlocked</span>
              <br />
              <b>{name}</b>
              <br />
              <span className="text-xs">{desc}</span>
            </span>
          ),
          {
            icon: '🏆',
            style: {
              borderRadius: '30px',
              background: '#090e1de3',
              color: '#fff',
              padding: '1rem 2rem',
            },
          }
        );
      }
    },
    [achievements, setAchievements]
  );

  useEffect(() => {
    if (!socket) return;
    // Listen for the "UNLOCK" event directly.
    socket.on('UNLOCK', handleUnlockEvent);

    return () => {
      socket.off('UNLOCK', handleUnlockEvent);
    };
  }, [socket, handleUnlockEvent]);
};
